import { Component, Input } from '@angular/core';

import { ConsumerMoneyDeviceProvider } from '../../providers/consumer-money-device';
import { BaseListPage } from '../../providers/base-list-page';

@Component({
  selector: 'consumer-device-list',
  templateUrl: 'consumer-device-list.html'
})
export class ConsumerDeviceListComponent extends BaseListPage {
	@Input('business') business;

	constructor(
		public mainProvider: ConsumerMoneyDeviceProvider, 	
	) {
		super();
	}

	ngOnInit(){
		this.mainProvider.getDevices({businessId: this.business.Id})
	}

	bindToggle(deviceId, bind){
		if(this.isWorking()) return;

		this.startWorking(deviceId);

		this.mainProvider.bind({deviceId: deviceId, bind: bind})
		.then((data)=>{
			this.stopWorking();

			this.mainProvider.getDevices({businessId: this.business.Id})
		})
	}
}



// WEBPACK FOOTER //
// ./src/components/consumer-device-list/consumer-device-list.ts